// @vendors
import { Outlet } from 'react-router-dom';

// @components
import Header from '../header/Header';
import Footer from '../footer/Footer';
import UserRoleNavigation from '../../components/header/UserRoleNavigation';

// @store
import { useThemeStore } from '../../store/useThemeStore';

export const BaseLayout = () => {
  const { isDarkMode } = useThemeStore();
  return (
    <div className={`min-h-screen ${isDarkMode ? 'dark' : ''} dark:bg-dark-cBackground`}>
      <div className="bg-white dark:bg-dark-cBackground text-cText dark:text-white relative z-20 flex flex-col h-screen">
        <Header/>
        <UserRoleNavigation />
        <main className="3xl:container 3xl:mx-auto">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
};